const EventEmitter = require('eventemitter3');

let _instance;
const CoreMessageDispatcher = {};

// Singleton: CoreMessageDispatcher

CoreMessageDispatcher.instance = () => {
    if (_instance) return _instance;
    _instance = new EventEmitter();
    return _instance;
};

CoreMessageDispatcher.destroy = () => {
    const instance = _instance;
    _instance = undefined;
    return instance;
};

export default CoreMessageDispatcher;
export {CoreMessageDispatcher};
